import { DatePicker } from "antd";
import styles from "./Appointment.module.css";

const AppointmentDatePicker = ({ date, setDate }) => {
  const onChange = (date) => {
    setDate(date);
  };

  return (
    <div className="w-full">
      <DatePicker.RangePicker
        allowClear={false}
        value={date}
        onChange={onChange}
        className={styles.DatePicker}
        popupClassName="dateRangePicker"
      />
    </div>
  );
};

export default AppointmentDatePicker;
